/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PutUsersPreferencesUnitsOptions, PutUsersPreferencesUnitsResponses } from '../types/PutUsersPreferencesUnits'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Replaces all existing preferences of the user for the provided types with the new values.
 * {@link /users/preferences/units/}
 */
export function putUsersPreferencesUnits<ThrowOnError extends boolean = true>(options: Options<PutUsersPreferencesUnitsOptions, ThrowOnError>): Unwrappable<RequestResult<PutUsersPreferencesUnitsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PUT', url: '/users/preferences/units/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PutUsersPreferencesUnitsResponses, ThrowOnError>>)
}
